import React, { useState, FC, PropsWithChildren, useEffect } from "react"

import { collection, FirestoreError, onSnapshot, query, orderBy, limit } from "firebase/firestore"

import { HealthContext, HealthDocument } from "."
import { firebase } from "../../services/firebase/firebase"
import healthConverter from "./utils/healthConverter"
import { Outlet } from "react-router-dom"
import { DeviceDocument } from "../devices-context"

type HealthProviderProps = {
    device: DeviceDocument
    route?: boolean
}

export const HealthProvider: FC<PropsWithChildren<HealthProviderProps>> = ({ device, route = false, children }) => {
    const [data, setData] = useState<HealthDocument[]>([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<FirestoreError>()

    useEffect(
        () =>
            onSnapshot(
                query(
                    collection(
                        firebase.firestore,
                        `organisations/${device.organisation}/things/${device.id}/health`,
                    ),
                    orderBy("timestamp", "desc"),
                    limit(1000),
                ).withConverter(healthConverter),
                snapshot => {
                    setData(snapshot.docs.map(doc => doc.data()))
                    setLoading(false)
                },
                setError,
            ),
        [device],
    )

    return (
        <HealthContext.Provider value={{ data, loading, error }}>
            {route ? <Outlet /> : children}
        </HealthContext.Provider>
    )
}
